/**
 * Shared rules on how an add to cart is confirmed: by opening the minicart panel
 * or by the alert message. The switch is rendered server-side by Cart-MiniCart
 * (off in the loyalty app and on the cart page).
 */

'use strict';

const SELECTORS = {
    settings: '.js-minicart-settings'
};

/**
 * Whether the minicart panel replaces the add to cart alert on the current page
 * @returns {boolean} true when the panel is enabled
 */
const isEnabled = () => $(SELECTORS.settings).first().data('panelOnAddToCart') === true;

/**
 * Whether an add to cart response asks the customer to choose bonus products first
 * @param {Object} response - add to cart AJAX response
 * @returns {boolean} true when the bonus products dialog is going to be shown
 */
const hasBonusChoice = (response) => !!(response
    && response.newBonusDiscountLineItem
    && Object.keys(response.newBonusDiscountLineItem).length !== 0);

/**
 * Whether a successful add to cart is confirmed right away by the minicart panel
 * (instead of the alert). With a bonus choice the panel opens once its dialog is closed.
 * @param {Object} response - add to cart AJAX response
 * @returns {boolean} true when the panel will open
 */
const opensOnAddToCart = (response) => isEnabled()
    && !!response
    && !response.error
    && !hasBonusChoice(response);

module.exports = {
    isEnabled: isEnabled,
    hasBonusChoice: hasBonusChoice,
    opensOnAddToCart: opensOnAddToCart
};
